import React from 'react';
import type { Locales } from 'cms/cms-types';
import { type Filter, type ListingFiltersState } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { type ListingPaginationState } from '3-components/ListingApp/ListingPagination/ListingPagination';
import { type ListingUILabel } from '3-components/ListingApp/ListingUI/ListingUI';

export type AppStatus = 'initial-loading' | 'fetching' | 'initial-error' | 'error' | 'ready';

export interface SearchBlockLabel extends ListingUILabel {
    noValueSearchForLabel: string;
    withValueSearchForLabel: string;
}

export interface SearchBlockCMSConfig {
    apiKey: string;
    apiUrl?: string;
}

export interface TagsLabelItem {
    value: string;
    label: string;
}

export interface SearchBlockProps {
    locale: Locales;
    cms: SearchBlockCMSConfig;
    label: SearchBlockLabel;
    listing: {
        filters?: Filter[];
        filterByAncestors?: string[];
        itemsPerPage: number;
        tagsLabel?: TagsLabelItem[];
        ancestorsTagLabel?: TagsLabelItem[];
        ancestorLimit?: number;
        firstAncestor?: string;
    };
}

export interface SearchBlockContextProps extends SearchBlockProps, ListingFiltersState, ListingPaginationState {
    // appStatus: AppStatus;
    // setAppStatus: React.Dispatch<React.SetStateAction<AppStatus>>;
    // errorMessage: string;
    // setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

const SearchBlockContext = React.createContext<Partial<SearchBlockContextProps>>({});

export default SearchBlockContext;
